import { IconButton } from "@vapor/material";
import { useSnackbar } from "notistack";
import { useCallback } from "react";
import { getErrorMessage } from "src/utils/utils";
import CloseIcon from '@mui/icons-material/Close';

const useErrorSnackBar = () => {

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const showErrorSnackBar = useCallback((error: unknown) => {
        return enqueueSnackbar(
            getErrorMessage(error),
            {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                action: (key) => {
                    return <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.5 }}
                        onClick={() => { closeSnackbar(key) }}
                    >
                        <CloseIcon />
                    </IconButton>
                }
            }
        )
    }, [enqueueSnackbar, closeSnackbar]);

    return showErrorSnackBar
}

export default useErrorSnackBar